const Spotify = () => {

  return (
    <iframe 
      title="spotify"
      src="https://open.spotify.com/embed/playlist/041Oz2XCIHOUT1MyGK8ywZ?utm_source=generator&theme=0" 
      width="100%" 
      height="100%" 
      frameBorder="0" 
      allowfullscreen="" 
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" ></iframe>
  );
}

export default Spotify;